import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'
import { useTranslation } from 'react-i18next'

const SurvivalRiskPage = () => {
  const { t } = useTranslation()
  const parentBreadcrumbs = [
    { label: t('header.home'), path: '/' },
    { label: t('header.service'), path: '/service' },
    { label: t('header.services.aiMl.title'), path: '/service/ai-ml' },
    { label: t('aiMlOverview.clinicalResearch.title'), path: '/service/ai-ml/clinical-research' }
  ]
  return (
    <TechnicalServicePage 
      serviceKey="survivalRisk" 
      parentBreadcrumbs={parentBreadcrumbs}
    />
  )
}

export default SurvivalRiskPage
